import { render, staticRenderFns } from "./MusicFeed.vue?vue&type=template&id=2a3bd7f3&scoped=true&"
import script from "./MusicFeed.vue?vue&type=script&lang=js&"
export * from "./MusicFeed.vue?vue&type=script&lang=js&"
import style0 from "./MusicFeed.vue?vue&type=style&index=0&id=2a3bd7f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3bd7f3",
  null
  
)

export default component.exports